import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const PhoneIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.3 4.75h-1.9A1.65 1.65 0 0 0 4.75 6.4C4.75 13.5 10.5 19.25 17.6 19.25a1.65 1.65 0 0 0 1.65-1.65v-1.9a1 1 0 0 0-.75-.97l-2.9-.75a1 1 0 0 0-1.03.4l-.95 1.3a10.3 10.3 0 0 1-5.3-5.3l1.3-.95a1 1 0 0 0 .4-1.03l-.75-2.9a1 1 0 0 0-.97-.75Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
        />
    </svg>
)

const PhoneIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {PhoneIconSvg}
    </SvgIcon>
)

export default PhoneIcon
